// export const URL = "http://localhost:8000/";

export const URL = "https://api.ontest.com.br/";
// export const URL = "https://onteste.enterscience.com.br/";

// export const URL = "https://onteste.itec.edu.br/";
